import React, { useState } from 'react';
import Typography from '../../typography';
import Grid from '../../grid';
import { TimeRange } from './availability_step_context';
import { Time } from '../../../utils/time';
import TextField from '../../textfield';
import Autocomplete from '../../autocomplete';

interface IntervalProps {
  timeRange?: TimeRange
  onSetTimeRange: (timeRange?: TimeRange) => void
}

const wholeDayTimeRange = Time.getWholeDayTimeslots(15).map((time) => time.toString());
const emptyTime = '--';

const Interval: React.FC<IntervalProps> = ({ timeRange, onSetTimeRange }) => {
  const [startTime, setStartTime] = useState(timeRange?.startTime
    ? Time.fromTime(timeRange.startTime).toString()
    : emptyTime
  );
  const [endTime, setEndTime] = useState(timeRange?.endTime
    ? Time.fromTime(timeRange.endTime).toString()
    : emptyTime);
  const [initialTimeIntervalSet, setInitialTimeIntervalSet] = useState(!!timeRange);

  React.useEffect(() => {
    if (initialTimeIntervalSet && (startTime === emptyTime || endTime === emptyTime)) {
      setStartTime(emptyTime);
      setEndTime(emptyTime);
      onSetTimeRange(undefined);
    }
    if (!startTime || !endTime) return;
    if (startTime === emptyTime || endTime === emptyTime) return;
    try {
      const parsedStartTime = Time.fromString(startTime);
      const parsedEndTime = Time.fromString(endTime);
      onSetTimeRange({
        startTime: {
          hour: parsedStartTime.hour,
          minute: parsedStartTime.minute
        },
        endTime: {
          hour: parsedEndTime.hour,
          minute: parsedEndTime.minute
        }
      })
      setInitialTimeIntervalSet(true);
    } catch (e) {
      setStartTime(emptyTime);
      setEndTime(emptyTime);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, endTime]);

  const selectableStartTime = React.useMemo(() => {
    if (endTime === emptyTime) return wholeDayTimeRange;
    const parsedEndTime = Time.fromString(endTime);
    return wholeDayTimeRange.filter((time) => {
      const parsedTime = Time.fromString(time);
      return parsedTime.hour < parsedEndTime.hour || (parsedTime.hour === parsedEndTime.hour && parsedTime.minute < parsedEndTime.minute);
    })
  }, [endTime]);

  const selectableEndTime = React.useMemo(() => {
    if (startTime === emptyTime) return wholeDayTimeRange;
    const parsedStartTime = Time.fromString(startTime);
    return wholeDayTimeRange.filter((time) => {
      const parsedTime = Time.fromString(time);
      return parsedTime.hour > parsedStartTime.hour || (parsedTime.hour === parsedStartTime.hour && parsedTime.minute > parsedStartTime.minute);
    })
  }, [startTime]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <Autocomplete
          fullWidth
            value={startTime}
            onChange={(_, value) => {
              if (value) {
                setStartTime(value);
              } else {
                setStartTime(emptyTime);
              }
            }}
          options={[emptyTime, ...selectableStartTime]}
          renderInput={(params) => <TextField {...params} />}
         />
        {/* <TextField fullWidth select value={startTime} onChange={onChangeStartTime}>
          <MenuItem value={emptyTime}>{emptyTime}</MenuItem>
          {selectableStartTime.map((time, index) => (
            <MenuItem key={index} value={time.toString()}>{time.toString()}</MenuItem>
          ))}
        </TextField> */}
      </Grid>
      <Grid item xs={1}>
        <Typography textAlign={'center'}>-</Typography>
      </Grid>
      <Grid item xs={5}>
        <Autocomplete
          fullWidth
          value={endTime}
          onChange={(_, value) => {
            if (value) {
              setEndTime(value);
            } else {
              setEndTime(emptyTime);
            }
          }}
          options={[emptyTime, ...selectableEndTime]}
          renderInput={(params) => <TextField {...params} />}
         />
      </Grid>
    </Grid>
  )
}

export default Interval;
